import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router-dom'

import { isNil } from 'lodash-es'
import { bindActionCreators } from 'redux'
import { reduxForm } from 'redux-form/immutable'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'
import BootstrapContainer from '@lyrahealth-inc/ui-core/lib/molecules/layouts/bootstrapContainer/BootstrapContainer'

import styles from './clientEmail.module.scss'
import ThankYou from './ThankYou'
import ClientEmailForm from '../../common/components/forms/clientEmail/ClientEmailForm'
import clientEmailValidate from '../../common/components/forms/clientEmail/clientEmailValidate'
import { REQUEST_PAYMENT } from '../../common/constants/routingConstants'
import { getErrorText } from '../../common/utils/utils'
import * as alertActions from '../../data/alertActions'
import * as providersDataActions from '../../providers/data/providersDataActions'
type ClientEmailProps = {
  handleSubmit?: (...args: any[]) => any
  submitting?: boolean
  actions?: any
  navigate: NavigateFunction
  location: Location
}

class ClientEmail extends Component<ClientEmailProps> {
  _submitForm = (values: any) => {
    this.props.actions.hideAlerts()
    const {
      actions: { submitClientEmail, submitClientEmailForHealthPlan },
    } = this.props
    const formData = new FormData()
    const vals = values.toJS()
    Object.keys(vals).forEach((key) => {
      formData.append(key, vals[key])
    })

    const emailPromises = [submitClientEmail(this.props.location.state.patient_id, formData)]
    if (this.props.location.state.isHealthPlanEligible) {
      formData.append('company', this.props.location.state.company)
      emailPromises.push(submitClientEmailForHealthPlan(this.props.location.state.patient_id, formData))
    }
    return Promise.all(emailPromises).then(
      () => {
        this._continue(true)
      },
      (error) => {
        const errorText = error?.response?.data?.message || getErrorText(error?.response?.status) || 'Network error'
        this.props.actions.addAlert({
          show: true,
          contents: errorText,
          style: 'danger',
          expires: true,
        })
      },
    )
  }

  _continue = (submitted: any) => {
    if (submitted) {
      this.props.actions.addAlert({
        show: true,
        contents: "Thank you! Your client's email was successfully submitted",
        style: 'success',
        expires: false,
        autoDismissTimer: 4000,
      })
    }
    this.props.navigate(REQUEST_PAYMENT.route, { state: { fromSubmissionIntermediate: true } })
  }

  render() {
    const { handleSubmit, submitting, navigate, location } = this.props

    if (isNil(location.state)) {
      return navigate(REQUEST_PAYMENT.route)
    }
    return (
      <ContentLayout>
        <BootstrapContainer>
          <div className={styles.card}>
            <ClientEmailForm
              thankyou={
                <ThankYou
                  initialSession={location.state.initialSession}
                  sessionsLeft={location.state.sessionsLeft}
                  firstName={location.state.firstName}
                  lastName={location.state.lastName}
                  customer={location.state.customer}
                  programDisplayName={location.state.programDisplayName}
                />
              }
              handleSubmit={handleSubmit}
              submitFunction={this._submitForm}
              submitting={submitting}
              continueFunction={this._continue}
              firstName={location.state.firstName}
              lastName={location.state.lastName}
            />
          </div>
        </BootstrapContainer>
      </ContentLayout>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ ...providersDataActions, ...alertActions }, dispatch),
  }
}

const ConnectedClientEmail = connect(
  null,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'clientEmailForm',
    validate: clientEmailValidate,
    touchOnBlur: false,
    // @ts-expect-error TS(2345): Argument of type 'typeof ClientEmail' is not assig... Remove this comment to see the full error message
  })(ClientEmail),
) as React.ComponentType<{ navigate: NavigateFunction; location: Location }>

export default function ClientEmailWithRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  return <ConnectedClientEmail navigate={navigate} location={location} />
}
